var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createClient, createConfig } from "@hey-api/client-fetch";
import { sanitizeBaseUrl } from "../../../utils/evo";
import { meProductRegister } from "../../evo-client/__generated__";
export class IrsApiEvo {
    constructor(baseUrl, tenantToken, ciamToken) {
        this.tenantToken = tenantToken;
        this.ciamToken = ciamToken;
        this.client = createClient(createConfig({ baseUrl: sanitizeBaseUrl(baseUrl), throwOnError: true }));
    }
    registerPackCode(code) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                const { data } = yield meProductRegister({
                    client: this.client,
                    body: {
                        code,
                    },
                    headers: { "X-DES-CONSUMER-IAM-TOKEN": this.ciamToken, "X-DES-TENANT": this.tenantToken },
                });
                const hasInventory = !!(data === null || data === void 0 ? void 0 : data.inventory);
                return {
                    hasError: false,
                    isValid: hasInventory,
                    limitReached: !!(data === null || data === void 0 ? void 0 : data.is_genuine) && !!(data === null || data === void 0 ? void 0 : data.is_registrable) && !hasInventory,
                    loyalty_rule: (_a = data === null || data === void 0 ? void 0 : data.loyalty_rule) !== null && _a !== void 0 ? _a : null,
                };
            }
            catch (thrownError) {
                const { error } = thrownError;
                const limitReached = !!(error === null || error === void 0 ? void 0 : error.is_genuine) && !!(error === null || error === void 0 ? void 0 : error.is_registrable) && !error.inventory;
                return {
                    hasError: true,
                    limitReached: limitReached || false,
                    isValid: false,
                    loyalty_rule: null,
                };
            }
        });
    }
}
//# sourceMappingURL=IrsApiEvo.js.map